"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var commands = require("../commands");
var ui = require("../../ui");
var socketClient_1 = require("../../../socket/socketClient");
commands.gitFetchLatestAndRebase.on(function () {
    ui.notifyInfoNormalDisappear("Git: Sending commands. Will notify when complete.");
    socketClient_1.server
        .gitFetchLatestAndRebase({})
        .then(function (res) {
        if (res.type === 'error') {
            ui.notifyWarningNormalDisappear("Git Failed:" + res.error);
        }
        else {
            ui.notifySuccessNormalDisappear(res.log);
            ui.notifySuccessNormalDisappear("Git: Commands ran to completion successfully.");
        }
        commands.gitStatusNeedsRefresh.emit({});
    });
});



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/commands/general/gitFetchLatestAndRebase.js
 ** module id = 393
 ** module chunks = 0
 **/